import { createIcon } from './createIcon'

export const AnalyticsExpandIcon = createIcon({
  displayName: 'AnalyticsExpandIcon',
  viewBox: '0 0 12 12',
  path: [
    <path
      d="M0 12V6.66667H1.33333V9.73333L9.73333 1.33333H6.66667V0H12V5.33333H10.6667V2.26667L2.26667 10.6667H5.33333V12H0Z"
      fill="currentColor"
    />,
  ],
})
